import InputFileUpload from "../components/InputFileUpload";
import {useContext, useEffect, useState} from "react";
import { Context } from "../index";
import { observer } from "mobx-react-lite";
import { getUploads } from "../http/uploadsApi";
import RuleChooser from "../components/rule/RuleChooser";
import Button from "@mui/material/Button";
import ContractChooser from "../components/contract/ContractChooser";
import { useNavigate } from "react-router-dom";
import {FILE_ROUTE, LOGIN_ROUTE, UPLOAD_ROUTE} from "../utils/constants";
import PeriodChooser from "../components/PeriodChooser";
import { jwtDecode } from "jwt-decode";
import * as React from "react";
import {getReportData} from "../http/reportApi";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {DataGrid} from "@mui/x-data-grid";

const Upload = observer(() => {
  const navigate = useNavigate();
  const { user } = useContext(Context);
  const [data, setData] = React.useState([]);

    const getList = async () => {
        try {
            const response = await getUploads();
            const res = response.map((item) => {
                // console.log(new Date(item.createdAt).toLocaleString('ru-RU'), item);
                return {
                    ...item,
                    createdAt: new Date(item.createdAt).toLocaleString('ru-RU')
                }
            });

            setData(res);
        } catch (error) {
            if (error.response.status === 401) {
                localStorage.clear();
                user.setIsAuth(false);
                return navigate(LOGIN_ROUTE);
            }
        }
    };

  useEffect(() => {
      (async ()=>{
          await getList();
      })();
  }, []);

  const rowClick = async (info)=>{
      console.log(info);
      navigate(FILE_ROUTE + "/" + info.id);
  }

  let columns = [];
  columns.push({
      field: "createdAt",
      headerName: "Дата загрузки",
      width: 180,
      editable: false,
      sortable: true,
  });
  columns.push({
      field: "provider",
      headerName: "Контент-Провайдер",
      width: 180,
      editable: false,
      sortable: true,
  });
  columns.push({
      field: "fileName",
      headerName: "Файл",
      width: 230,
      editable: false,
      sortable: true,
  });
  columns.push({
      field: "period",
      headerName: "Квартал",
      width: 100,
      editable: false,
      sortable: true,
  });
  columns.push({
      field: "authorTotal",
      headerName: "Сумма авторских",
      width: 150,
      editable: false,
      sortable: true,
      renderCell: (params) => {
          return params.value ? params.value.toLocaleString() : '';
      }
  });
  columns.push({
      field: "relatedTotal",
      headerName: "Сумма смежных",
      width: 150,
      editable: false,
      sortable: true,
      renderCell: (params) => {
          return params.value ? params.value.toLocaleString() : '';
      }
  });
    columns.push({
        field: "summary",
        headerName: "Сумма",
        width: 150,
        editable: false,
        sortable: true,
        renderCell: (params) => {
            return params.value ? params.value.toLocaleString() : '';
        }
    });

  return (
      <div
          style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
          }}
      >
          <Box
              display="flex"
              alignItems="center"
              flexDirection="row"
              justifyContent="flex-end"
              width={'100%'}
              p={2}
          >
              <Button
                  color="secondary"
                  variant="outlined"
                  onClick={()=>{
                      navigate(UPLOAD_ROUTE + "/form")
                  }}
              >Загрузить файл</Button>
          </Box>
          {data && columns && (
              <Box sx={{ height: "100%", width: "100%" }}>
                  <DataGrid
                      rows={data}
                      columns={columns}
                      autosizeOptions={{
                          // columns: ['fileName', 'period', 'summary', 'authorTotal', 'relatedTotal'],
                          includeOutliers: true,
                          includeHeaders: true,
                      }}
                      initialState={{
                          pagination: {
                              paginationModel: {
                                  pageSize: 100,
                              },
                          },
                      }}
                      pageSizeOptions={[10, 20, 50, 100]}
                      disableRowSelectionOnClick
                      onRowClick={rowClick}
                  />
              </Box>
          )}
      </div>
  );
});

export default Upload;
